module.exports = __webpack_public_path__ + "img/13step-03-03-1_ergebnis.39424b13.png";